import PostRequest from "csi/comm/PostRequest";
import AttributeController from "csi/heading/AttributeController";
import declare from "dojo/_base/declare";
import xml from "csi/xml";

const KeycloakSecretController = declare(AttributeController, {

	/**
		 * @override
		 * Get KeycloakSecret value
		 */
	process() {
		const postReq = new PostRequest("SiteAdmin", "GetKeycloakSecret").addParameter("URL", this.m_urlNode);
		this.waitForPublish(postReq.post());
	},

	/**
		 * @override
		 * Create attribute KeycloakSecret on the node
		 */
	postProcessSuccess() {
		xml.nodeCreateClientAttr(this.getNode(), "KeycloakSecret", xml.ATTR_STRING, this.m_response.getReturnValue());
		this._refresh(true);
	},
});

export = KeycloakSecretController;
